<template>
  <div class="inp_container brains-type1-number-input" :class="{ 'brains-input--disabled' : disabled }">
    <input v-model="displayValue" :placeholder="placeholder" type="text" :disabled="disabled" @blur="isInputActive = false" @focus="isInputActive = true">
  </div>
</template>

<script>
export default {
  name: 'NumInput',
  props: {
    value: {
      type: Number,
      default: 0
    },
    decimals: {
      type: Number,
      default: 2
    },
    suffix: {
      type: String,
      default: '€'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minVal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.value === undefined || this.value === null) { return }
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          // return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, '$1.') + ' €'
          return this.value.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: this.decimals }) + ' ' + this.suffix
        }
      },
      set: function(modifiedValue) {
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
        if (isNaN(newValue)) {
          newValue = 0
        }
        if (newValue < this.minVal) {
          newValue = this.minVal
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.inp_container, .inp_container > input {
  width: 100%;
  height: 100%;
}

.brains-input--disabled input {
  background-color: rgb(240, 240, 240) !important;
  outline: 1px solid rgb(221, 221, 221);

  &:hover {
    outline-color: rgb(221, 221, 221);
  }
}
</style>
